import {downloadFile} from "./download";

export function initView() {
  let viewIdentifier = document.body.dataset.viewIdentifier;
  viewInitializers[viewIdentifier]?.();
}

const viewInitializers = {
  "activity-export-new": () => {
    document.getElementById('activity-form').addEventListener('submit', (evt => {
      evt.preventDefault();

      const validationAlertElement = document.getElementById('validation-alert');
      const eventTypes = document.querySelectorAll('input[name="event-types"]:checked');

      if(eventTypes.length > 0) {
        validationAlertElement.classList.add('hidden');

        const formElement = document.getElementById('activity-form');
        const formData = new FormData(formElement);
        const url = formElement.action;

        downloadFile(url, "Activity.xlsx", "#preparing-download", "POST", formData)
      }
      else {
        validationAlertElement.classList.remove('hidden');
      }
    }));
  },
  "leadgroup-show": () => {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if(params.get('export')) {
      params.delete('export');

      let updatedUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, null, updatedUrl);
    }
  },
  "faq-show": () => {


    let params = new URLSearchParams(document.location.search),
        vid = params ? params.get("autoplay") : null;
    console.log("faq loading");
    console.log(window.wistaEnabled);
    if(vid && window.wistiaEnabled) {

      const parser = new DOMParser();
      const doc = parser.parseFromString('<div class="load-container video-loader"><div class="loader"><span class="ldr-blk"></span><span class="ldr-blk an_delay"></span><span class="ldr-blk an_delay"></span><span class="ldr-blk"></span></div></div>', 'text/html');
      const loadNode = doc.body.firstElementChild;

      document.body.prepend(loadNode);

      //console.log(vid);
      window._wq = window._wq || [];
      _wq.push({ id: vid, onReady: function(video) {
        video._attrs.autoplay = false;
        video._attrs.popoverAnimateThumbnail = false;
        video._attrs.silentAutoPlay = false;
        video.bind("popovershow", function() {
          setTimeout(() => {loadNode.remove()}, 500);
        });
        video.popover.show();
        window.vid = video;
      }});
    }
  }
}
